import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

import { config, genericModule, FlowEditor, Debugger, Estero, Hub } from './modules'

import createWebSocketPlugin from './plugins/WebsocketPlugin'
import createDbCachePlugin from './plugins/DbCachePlugin'

Vue.use(Vuex)

const state = {
  saveStateDirty: false,
  currentUser: '',
  flowSearchTerm: '',
  mainMenuPinned: true,
  fieldSearchTerm: '',
  allowDefaultPrefUse: false,
  savesRequested: 0, // ctrl + s increments this counter
  pendingTasks: []
}

const websocketPlugin = createWebSocketPlugin()
const dbCachePlugin = createDbCachePlugin()

export const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    config: config,
    application: genericModule,
    applicationtype: genericModule,
    field: genericModule,
    flow: genericModule,
    group: genericModule,
    manufacturer: genericModule,
    service: genericModule,
    subject: genericModule,
    table: genericModule,
    user: genericModule,
    estero_alert: genericModule,
    estero_alert_log: genericModule,
    hub: Hub,
    manatee_settings: genericModule,
    flow_restrictions: genericModule,
    flowEditor: FlowEditor,
    debugger: Debugger
  },
  plugins: process.env.NODE_ENV !== 'test' ? [websocketPlugin, dbCachePlugin] : [],
  strict: process.env.NODE_ENV !== 'production'
})

if (module.hot) {
  module.hot.accept(['./getters', './actions', './mutations'], () => {
    store.hotUpdate({
      getters: require('./getters'),
      actions: require('./actions'),
      mutations: require('./mutations')
    })
  })
}

export ActionTypes from './action-types'
export MutationTypes from './mutation-types'
